import React, { useEffect, useState, useContext } from 'react';
import { useHistory } from "react-router-dom";
import { customStyle } from './HeaderStyle'
import { texts, properties, mockRRSS, mockMenu, mock } from './HeaderData'
import { properties as appProperties, compProperties, texts as appTexts } from '../../../AppData';
import Reloj from '../reloj/Reloj';
import TabMenu from '../tabMenu/TabMenu';
import Breadcrumbs from 'components/commons/breadcrumb/breadcrumb';
import HamburgerMenu from '../hamburgerMenu/HamburgerMenu';
import { Grid } from '@material-ui/core';
import MenuCuenta from '../../commons/menuCuenta/menuCuenta';
import PopUp from '../../commons/popUp/popUp';
import MenuUsuario from '../../pages/menuUsuario/menuUsuario';
import Confirmacion from '../../commons/Confirmacion/Confirmacion';
import { localStorageName } from './../../../providers/localStorageData';
import AuthProvider from './../../../providers/authProvider';
import useApp from 'AppFunctions';
import AppContext from 'AppContext';
import { HelpOutlineRounded } from '@material-ui/icons';
import PopUpHerramientas from '../popUpHerramientas/PopUpHerramientas';
import { getUrl } from 'config/Config';
import axios from 'axios';
import { properties as propertiesCloudConfig } from '../../../config/Config';
import RestProvider from 'providers/RestProvider';
import { useSelector, useDispatch } from 'react-redux';
import { insertNewState, deleteState } from 'redux/slicers/kingdomOV3Slice';

export default function Header() {

    let logo = propertiesCloudConfig['CONSEJERIA_LOGO_PC'];
    let logoMovil = propertiesCloudConfig['CONSEJERIA_LOGO_MOVIL'];
    let consejeria = propertiesCloudConfig['CONSEJERIA_NOMBRE'];
    const [isPhoneVersion, setIsPhoneVersion] = useState(false);
    const history = useHistory();
    const [menuMiCuenta, setMenuMiCuenta] = useState(false);
    const [mostrarConfirmacion, setMostrarConfirmacion] = useState(false);
    const context = useContext(AppContext);
    const { loginClave } = useApp();
    const { logout, checkCloudProperties } = AuthProvider();
    const [menuData, setMenuData] = useState([]);
    const [rrSs, setRrss] = useState(mockRRSS);
    const [nombreConsejeria, setNombreConsejeria] = useState();
    const [logoConsejeria, setLogoConsejeria] = useState();
    const [logoConsejeriaMovil, setLogoConsejeriaMovil] = useState();
    const [tlfProcedimiento, setTlfProcedimiento] = useState();
    const { crudOperation, crudOperationsType } = RestProvider();

    const dispatch = useDispatch();
    const infoUsuario = useSelector((state) => state.kingdomOV3.infoUsuario);
    const tipoProcedimientos = useSelector((state) => state.kingdomOV3.tipoProcedimientos);
    const procedimientoActual = useSelector((state) => state.kingdomOV3.procedimientoActual);

    useEffect(() => {
        loadCloudInfo();
    }, []);

    useEffect(() => {
        if (context.sesion === appProperties.SESION_CADUCADA) {
            setMostrarConfirmacion(true);
        }
        updateFormat();
        loadMenuData();
    }, [context.sesion]);

    const loadMenuData = async () => {
        await checkCloudProperties(100);
        let url = propertiesCloudConfig['URL_API_HEADER'];

        if (url) {
            let dataObtenerRecursoApiGrafica = { 'url': url }
            crudOperation(crudOperationsType.CUSTOM, 'footer', { url: 'obtenerRecursoApiGrafica', method: 'post', data: dataObtenerRecursoApiGrafica }).then(function (response) {
                montarMenuData(response.data.contenidoHtml)
            }).catch(function (err) {
                setMenuData(mockMenu);
            });
        } else {
            setMenuData(mockMenu);
        }
    }

    const montarMenuData = (datos) => {
        let response = [];

        //Pasar datos de string a html
        var div = document.createElement('div');
        div.innerHTML = datos;

        let datosMenu = div.getElementsByClassName('menu-msd');
        if (datosMenu && datosMenu[0]) {
            let listadoApartado = datosMenu[0].children;

            // APARTADO
            for (let index = 0; index < listadoApartado.length; index++) {
                let apartado = listadoApartado[index];

                if (!apartado.className.includes('search')) {
                    let elementoApartadoTitulo = apartado.getElementsByClassName('dropdown-toggle');

                    if (elementoApartadoTitulo && elementoApartadoTitulo[0]) {
                        let enlaceApartado = elementoApartadoTitulo[0].getAttribute("href");
                        let elementoApartadoI = elementoApartadoTitulo[0].getElementsByTagName('i');
                        let tituloApartado = elementoApartadoTitulo[0].textContent.trim()
                        let imagenApartado;

                        if (elementoApartadoI && elementoApartadoI[0]) {
                            let nombreClase = elementoApartadoI[0].className;
                            let indexInicioImg = nombreClase.indexOf('fa-')
                            if (indexInicioImg !== -1) {
                                let indexFinalImg = nombreClase.indexOf(' ', indexInicioImg);
                                imagenApartado = nombreClase.substring(indexInicioImg, indexFinalImg !== -1 ? indexFinalImg : nombreClase.length);
                            }
                        } else {
                            let elementoApartadoImg = elementoApartadoTitulo[0].getElementsByTagName('img');
                            if (elementoApartadoImg && elementoApartadoImg[0]) {
                                //imagenApartado = elementoApartadoImg[0].getAttribute('src');
                                imagenApartado = "simbolo-generico_positivo"
                            }
                        }

                        imagenApartado = imagenApartado + '.svg';

                        //RESPONSE
                        let objetoApartado = {
                            tituloSeccion: tituloApartado,
                            enlace: enlaceApartado,
                            imagen: imagenApartado,
                            columnasPrincipales: montarPanelMenuData(apartado)
                        }
                        response.push(objetoApartado);
                    }
                }
            }
        }
        setMenuData(response);
    }

    const montarPanelMenuData = (apartado) => {

        // COLUMNA PRINCIPAL
        let listadoColumnasPrincipalesObjeto = [];
        let panel = apartado.getElementsByClassName("dropdown-menu");

        if (panel && panel[0]) {

            //COLUMNAS DEFAULT 
            let columnaPrincipalElemento = panel[0].getElementsByTagName('ul');

            if (columnaPrincipalElemento) {
                for (let index = 0; index < columnaPrincipalElemento.length; index++) {
                    let columnaPrincipal = columnaPrincipalElemento[index];
                    if (!columnaPrincipal.className.includes('enlaces-segundo-nivel') && !columnaPrincipal.className.includes('lista-menu-n2')) {

                        //COLUMNA
                        let listadoColumnas = columnaPrincipal.children;
                        let listadoColumnasObjeto = [];

                        if (listadoColumnas) {
                            for (let index2 = 0; index2 < listadoColumnas.length; index2++) {
                                let columna = listadoColumnas[index2];

                                let elementoTituloColumna = columna.firstElementChild;
                                let tituloColumna = "";
                                let enlaceColumna = "";
                                let tipoColumna = "default";
                                if (elementoTituloColumna && (elementoTituloColumna.tagName === 'A' || elementoTituloColumna.tagName === 'a')) {
                                    enlaceColumna = elementoTituloColumna.getAttribute('href');
                                    let spanTituloColumna = elementoTituloColumna.children;
                                    let col = (spanTituloColumna[0].textContent === '' && spanTituloColumna.length > 1 && spanTituloColumna[1].textContent !== undefined) ? 1 : 0;
                                    tituloColumna = spanTituloColumna[col].textContent;
                                }

                                if (tituloColumna) { //Evitar bloque Directo a
                                    let columnaObjeto = {
                                        tituloColumna: tituloColumna,
                                        tipoColumna: tipoColumna,
                                        enlace: enlaceColumna,
                                        filas: montarFilasMenuData(columna)
                                    }
                                    listadoColumnasObjeto.push(columnaObjeto);
                                }
                            }
                        }
                        let columnaPrincipalObjeto = {
                            columnas: listadoColumnasObjeto
                        }
                        listadoColumnasPrincipalesObjeto.push(columnaPrincipalObjeto);
                    }
                }
            }
            columnasDirectoA(panel, listadoColumnasPrincipalesObjeto);
        }

        return listadoColumnasPrincipalesObjeto;
    }

    const montarFilasMenuData = (columna) => {
        let listadoObjetoFilas = []

        //FILA
        let lista = columna.getElementsByTagName('ul');
        if (lista && lista[0]) {
            let listadoFilas = lista[0].children

            if (listadoFilas) {
                for (let index = 0; index < listadoFilas.length; index++) {
                    let fila = listadoFilas[index];

                    let elementoFila = fila.getElementsByTagName('a');
                    if (elementoFila && elementoFila[0]) {
                        let textoFila = "";
                        let imagenFila = "";
                        let enlaceFila = elementoFila[0].getAttribute('href');
                        let elementoTituloFila = elementoFila[0].getElementsByTagName('span');

                        if (elementoTituloFila && elementoTituloFila[0]) {
                            textoFila = elementoTituloFila[0].textContent;
                        } else {
                            textoFila = elementoFila[0].textContent
                        }

                        let objetoFila = {
                            texto: textoFila,
                            enlace: enlaceFila,
                            imagen: imagenFila
                        }
                        listadoObjetoFilas.push(objetoFila);
                    }
                }
            }
        }
        return listadoObjetoFilas;
    }

    const columnasDirectoA = (panel, listadoColumnasPrincipalesObjeto) => {
        let columnaPrincipalDirectoElemento = panel[0].getElementsByClassName('card-directo-a');
        if (columnaPrincipalDirectoElemento && columnaPrincipalDirectoElemento[0]) {

            let elementoFila = columnaPrincipalDirectoElemento[0].getElementsByTagName('li');
            let listadoFilasDirecto = [];

            if (elementoFila) {
                for (let index = 0; index < elementoFila.length; index++) {
                    let fila = elementoFila[index];

                    let elementoTitulo = fila.getElementsByTagName('a');
                    let enlaceFila = "";
                    let textoFila = "";
                    if (elementoTitulo && elementoTitulo[0]) {
                        enlaceFila = elementoTitulo[0].getAttribute('href');
                        textoFila = elementoTitulo[0].textContent
                    }

                    let elementoImagen = fila.getElementsByTagName('span');
                    let imagenFila = "";
                    if (elementoImagen && elementoImagen[0]) {
                        imagenFila = elementoImagen[0].className.trim();

                        let indexInicio = imagenFila.indexOf('fa-');
                        if (indexInicio !== -1) {
                            imagenFila = imagenFila.substring(indexInicio, imagenFila.length);
                        }

                        imagenFila = imagenFila + '.svg'
                    }

                    let filaObj = {
                        texto: textoFila,
                        enlace: enlaceFila,
                        imagen: imagenFila
                    }

                    listadoFilasDirecto.push(filaObj);
                }
            }

            let columnaPrincipalDirecto = {
                columnas: [
                    {
                        tituloColumna: 'Directo a',
                        tipoColumna: 'directo',
                        enlace: '',
                        filas: listadoFilasDirecto
                    }
                ]
            }
            listadoColumnasPrincipalesObjeto.push(columnaPrincipalDirecto);
        }
    }

    //Funcion para cerrar sesion
    const closeSession = () => {
        localStorage.removeItem(localStorageName.redirect);
        dispatch(deleteState({ filnedName: 'origenLogin' }));
        localStorage.removeItem('origenLogin');
        dispatch(insertNewState({ filnedName: 'loginOut', value: true }));

        logout();
        setMostrarConfirmacion(false);
        setMenuMiCuenta(true);

        if ((infoUsuario !== undefined && infoUsuario !== '') && infoUsuario.tipoAutenticacion == "cl") {
            dispatch(deleteState({ filnedName: 'infoUsuario' }));
            loginClave(properties.URL_LOGOUT);
        } else {
            dispatch(deleteState({ filnedName: 'infoUsuario' }));
            context.updateSesion(appProperties.SESION_CIERRE)
            document.location.href = getUrl();
        }
    }

    useEffect(() => {
        setMenuMiCuenta(!(infoUsuario && infoUsuario !== ''));
    }, [infoUsuario]);

    const style = customStyle();

    const onClickLogoJA = () => {
        history.push('/');
    }

    const onClickContacto = () => {
        history.push('/PantallaContacto');
    }

    const sesionCaducadaMostrarConfirmacion = accion => {
        setMostrarConfirmacion(accion);
    }

    /**
     * Metodo que renderiza de forma dinamica los iconos de las RRSS
     */
    const renderRRSS = () => {
        return (
            <ul className={style.lista}> {
                rrSs && rrSs.rowList.map((row) => {

                    let dotIndex = row.text.indexOf('.');
                    let altText = row.text.substring(0, dotIndex);

                    return (
                        <li className={style.elementoLista}>
                            <a target="_blank" className={style.linkRrss} href={row.link} title={properties.TITLE_RRSS + altText}>
                                <img className={style.iconoRRSS} src={properties.RRSS_ICON_PATH + row.text} alt={altText} />
                            </a>
                        </li>
                    )
                })}
            </ul>
        )
    }

    const loadCloudInfo = async () => {
        await checkCloudProperties(100);

        setNombreConsejeria(propertiesCloudConfig['CONSEJERIA_NOMBRE']);
        setLogoConsejeria(propertiesCloudConfig['CONSEJERIA_LOGO_PC']);
        setLogoConsejeriaMovil(propertiesCloudConfig['CONSEJERIA_LOGO_MOVIL']);
        let urlFacebook = propertiesCloudConfig['RRSS_URL_FACEBOOK'];
        let urlInstagram = propertiesCloudConfig['RRSS_URL_INSTAGRAM'];
        let urlTwitter = propertiesCloudConfig['RRSS_URL_TWITTER'];
        let urlYoutube = propertiesCloudConfig['RRSS_URL_YOUTUBE'];
        let urlFlickr = propertiesCloudConfig['RRSS_URL_FLICKR'];
        mockRRSS.rowList[0].link = urlTwitter;
        mockRRSS.rowList[1].link = urlFacebook;
        mockRRSS.rowList[2].link = urlInstagram;
        mockRRSS.rowList[3].link = urlYoutube;
        mockRRSS.rowList[4].link = urlFlickr;
        setRrss(mockRRSS);
    }

    /**Método que capta el tamaño de la ventana y actualiza actualiza
    ***el hook que controla cuando se da el salto a versión movil*/
    const updateFormat = () => {
        if (window.matchMedia(`(max-width: ${appProperties.NUM_PIX_MOVIL})`).matches) {
            setIsPhoneVersion(true);
        } else {
            setIsPhoneVersion(false);
        }
    };

    /**
     * Efecto creado para mostrar el número de teléfono, el nombre de la consejería y el logotipo de la consejería
     * asociado al procedimiento seleccionado.
     */
    useEffect(() => {
        if (procedimientoActual) {
            getConfiPorProcedimiento(procedimientoActual.idTipoProcedimiento);
        } else {
            setTlfProcedimiento(null);
            setNombreConsejeria(consejeria);
            setLogoConsejeria(logo);
            setLogoConsejeriaMovil(logoMovil);
        }
    }, [procedimientoActual]);


    function transformarTexto(cadena) {
        const acentos = { 'á': 'a', 'é': 'e', 'í': 'i', 'ó': 'o', 'ú': 'u', 'Á': 'A', 'É': 'E', 'Í': 'I', 'Ó': 'O', 'Ú': 'U' };
        // Paso 1. Elimina los espacios en blanco y los sustituye por un _ y establece todas las letras en mayúsculas
        cadena = cadena.replace(/\s+/g, '_').toLocaleUpperCase();
        // Paso 2. Elimina los acentos de las letras que lo contengan
        return cadena.split('').map(letra => acentos[letra] || letra).join('').toString();
    }
    /**
     * @function getConfiPorProcedimiento Función que obtiene la configuración del procedimiento seleccionado
     * @param {*} idProc Id del procedimiento seleccionado
     */
    const getConfiPorProcedimiento = (idProc) => {

        if (tipoProcedimientos !== undefined && tipoProcedimientos !== '') {
            // Paso 1. Se recorren los tipos de procedimientos obtenidos y se evalúa si su id conincide con el id del procedimiento seleccionado
            for (const procedimiento of tipoProcedimientos) {
                if (procedimiento.id === idProc) {
                    /**
                     * Paso 2. Se obtiene la descripción del procedimiento seleccionado y se obtiene
                     * las propiedades de cloudconfig que contiene el número de tlf, nombre de consejería, logo y logo móvil.
                     * En caso de que no exista una propiedad en cloudConfig no se setea.
                     */

                    // Teléfono
                    let propertyTlf = 'TELEFONO_SAC_' + transformarTexto(procedimiento.descripcion);
                    let tlfCloudConfig = propertiesCloudConfig[propertyTlf];
                    tlfCloudConfig && setTlfProcedimiento(tlfCloudConfig);

                    // Nombre consejería
                    let propertyNombreConsejeria = 'CONSEJERIA_NOMBRE_' + transformarTexto(procedimiento.descripcion);
                    let nombreConsejeriaCloudConfig = propertiesCloudConfig[propertyNombreConsejeria];
                    nombreConsejeriaCloudConfig && setNombreConsejeria(nombreConsejeriaCloudConfig);

                    // Logo consejería
                    let propertyUrlLogo = 'LOGO_CONSEJERIA_URL_' + transformarTexto(procedimiento.descripcion);
                    let urlLogoCloudConfig = propertiesCloudConfig[propertyUrlLogo];
                    urlLogoCloudConfig && setLogoConsejeria(urlLogoCloudConfig);

                    // Logo consejería versión móvil
                    let propertyUrlLogoMovil = 'LOGO_CONSEJERIA_MOVIL_URL_' + transformarTexto(procedimiento.descripcion);
                    let urlLogoMovilCloudConfig = propertiesCloudConfig[propertyUrlLogoMovil];
                    urlLogoMovilCloudConfig && setLogoConsejeriaMovil(urlLogoMovilCloudConfig);
                    break;
                }
            }
        }
    }

    window.addEventListener('resize', updateFormat);

    return (
        <header>
            <nav aria-label={texts.ALABEL_NAV}>
                {/*FRANJA NEGRA*/}
                {!isPhoneVersion && <Grid container className={style.gridSeccionUno} direction='row' justify='flex-end' alignItems='center'>

                    <Grid container className={style.gridSeccionUnoContacto} alignItems='center'>
                        <Grid container className={style.gridContacto}>
                            <HelpOutlineRounded className={style.iconoAyuda} />
                            <button className={style.textoContacto} onClick={onClickContacto}>{texts.CONTACTO}</button>
                        </Grid>
                    </Grid>

                    <Grid container className={style.gridSeccionUnoRRSS}>
                        {renderRRSS()}
                    </Grid>

                </Grid>}
            </nav>

            {/*FRANJA BLANCA*/}
            <Grid container className={isPhoneVersion ? style.gridSeccionDosPhone : style.gridSeccionDos}>

                {/*SUPERIOR*/}
                <Grid container className={isPhoneVersion ? style.gridSeccionDosArribaPhone : style.gridSeccionDosArriba} direction='row' justify='space-between'>

                    {/*IZQUIERDA*/}
                    <Grid container className={style.gridSeccionDosArribaJA} direction='row' alignItems='center'>
                        <Grid container className={style.gridLogoJA}>
                            {
                                isPhoneVersion ?
                                    <button className={style.botonHome} onClick={onClickLogoJA}><img className={style.iconoJAPhone} src={properties.JA_PHONE_ICON_PATH + logoConsejeriaMovil} alt={texts.ALT_JA + nombreConsejeria} /></button> :
                                    <button className={style.botonHome} onClick={onClickLogoJA}><img className={style.iconoJA} src={properties.JA_ICON_PATH + logoConsejeria} alt={texts.ALT_JA + nombreConsejeria} /></button>
                            }

                        </Grid>
                    </Grid>

                    {/*DERECHA*/}
                    {
                        !isPhoneVersion ? <TabMenu data={menuData} /> : <HamburgerMenu data={menuData} isLogeado={menuMiCuenta} handleChange={closeSession} />
                    }

                </Grid>


                {/*IZQUIERDA*/}
                {isPhoneVersion && <Grid container className={style.gridSeccionDosAbajo} direction='row' justify='space-between'>
                    <Grid container className={style.gridSeccionDosAbajoBreadcrumbs} alignItems='center'>
                        <Breadcrumbs></Breadcrumbs>
                    </Grid>
                </Grid>}

                {/*INFERIOR*/}
                {!isPhoneVersion && <Grid container className={style.gridSeccionDosAbajo} direction='row' justify='space-between'>

                    {/*IZQUIERDA*/}
                    <Grid container className={style.gridSeccionDosAbajoBreadcrumbs} alignItems='center'>
                        <Breadcrumbs />
                    </Grid>

                    {/*DERECHA*/}
                    <Grid container className={style.gridSeccionDosAbajoDerecha} direction='row' alignItems='center'>
                        {/*TELEFONO*/
                            (tlfProcedimiento !== undefined && tlfProcedimiento !== null && tlfProcedimiento !== '') &&
                            <Grid className={style.classGridTlf}>
                                <Grid item title={texts.ATENCION_CIUDADANIA}>
                                    <img className={style.iconoTelefono} src={properties.TLFN_ICON_PATH} alt={texts.ALT_TLFNO} />
                                </Grid>
                                <Grid item title={texts.ATENCION_CIUDADANIA}>
                                    <span className={style.telefono}>{tlfProcedimiento}</span>
                                </Grid>
                            </Grid>
                        }
                        <Grid item className={style.ayuda} title={texts.AYUDA_USUARIO}>
                            <PopUp />
                        </Grid>
                        <Grid item className={style.ayuda} title={texts.HERRAMIENTAS_ENLACES}>
                            <PopUpHerramientas />
                        </Grid>

                        {menuMiCuenta ? (
                            <Grid item>
                                <MenuCuenta />
                            </Grid>
                        ) : (
                            <Grid item>
                                <MenuUsuario handleChange={closeSession} />
                            </Grid>
                        )}
                    </Grid>
                </Grid>}
            </Grid>
            <Confirmacion handleChange={sesionCaducadaMostrarConfirmacion} mostrar={mostrarConfirmacion} isPhoneVersion={isPhoneVersion}
                titulo={'Sesión Caducada'}
                mensaje={'Su sesión ha expirado'}
                botonera={compProperties.CONFIR_SOLO_ACEPTAR}
                accionConfirmacion={closeSession}
                tamMarginTop={appProperties.COMFIRMAR_MARGINTOP_10}
                isPopUpPdf={false}
                textBotonConfirmarPersonalizado={false}
                isImagenPersonalizada={false}
                centrarContenido={true}
                isTextoEnriquecido={true} />
            {/*FRANJA VERDE*/}
            {!isPhoneVersion && <Grid container className={style.gridSeccionTres} direction='row' justify='space-between'>

                {/*IZQUIERDA*/}
                <Grid container className={style.gridSeccionTresTitulos} direction='row' alignItems='center'>
                    <Grid item className={style.gridOvTexto}>
                        <span className={style.ovTexto}>{texts.OV}</span>
                    </Grid>
                    <Grid item>
                        <span className={style.consejeriaTexto}>{nombreConsejeria}</span>
                    </Grid>
                </Grid>

                {/*DERECHA*/}
                <Reloj />

            </Grid>}
        </header>
    )
}
